import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { getBattlebotSlotCenterPixels } from '../components/BattlebotPortalOverlay';
import { GENERAL_HEAL_FLASH_IMAGE_SRC } from '../config/generalHealFlashEffect';
import './GeneralHealFlashEffect.css';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * heal.png flash centered on a battlefield unit slot for 2 seconds.
 */
export function UnitHealFlashEffect({ viewerZone, slotIndex, animationKey }) {
  const [anchor, setAnchor] = useState(null);
  const reducedMotion = prefersReducedMotion();

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!viewerZone || slotIndex == null) {
        if (!cancelled) setAnchor(null);
        return;
      }
      const center = getBattlebotSlotCenterPixels(viewerZone, slotIndex);
      if (center) {
        if (!cancelled) {
          setAnchor({
            x: center.x,
            y: center.y,
            size: 72,
          });
        }
        return;
      }
      if (attempt < 24 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setAnchor(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [viewerZone, slotIndex, animationKey]);

  if (!anchor) {
    return null;
  }

  const layer = (
    <div
      className={[
        'general-heal-flash-layer',
        reducedMotion ? 'general-heal-flash-layer--static' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden
      data-animation-key={animationKey}
    >
      <div
        className="general-heal-flash-root"
        style={{
          left: `${anchor.x}px`,
          top: `${anchor.y}px`,
          width: `${anchor.size}px`,
          height: `${anchor.size}px`,
        }}
      >
        <img
          className="general-heal-flash-img"
          src={GENERAL_HEAL_FLASH_IMAGE_SRC}
          alt=""
          draggable={false}
        />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default UnitHealFlashEffect;
